import React from 'react';
import Render from 'react-dom';
import AssetGuide from './components/vf-ag-next';
Render.render(<AssetGuide/>, document.getElementById('agContainer'));


/** WEBPACK FOOTER **
 ** app/app.js
 **/